import { SET_UPDATE_USER_SUCCESS } from '../constants/ActionTypes';

export default function setUpdateUserSuccess(form) {
    return {
        type: SET_UPDATE_USER_SUCCESS,
        form,
    };
}
